module.exports = __webpack_public_path__ + "media/images/post-placeholder-853f08c0ff903e96d5c0b3f6d74e97ae.jpg";